import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useThemeContext } from './context/ThemeContext';

// Extracted Components
import { Navbar } from './components/Landing/Navbar';
import { Hero } from './components/Landing/Hero';
import { FeaturesGrid } from './components/Landing/FeaturesGrid';
import { CourseCatalog } from './components/Landing/CourseCatalog';

import { Footer } from './components/Landing/Footer';

export const TrackSelection = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const { mode } = useThemeContext();
    const isLight = mode === 'light';
    const location = useLocation();

    // Handle hash scrolling for links like #catalog-section
    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace('#', '');
            const element = document.getElementById(id);
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        } else {
            window.scrollTo(0, 0);
        }
    }, [location.hash]);

    return (
        <Box sx={{
            minHeight: '100vh',
            width: '100vw',
            maxWidth: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: isLight
                ? 'radial-gradient(ellipse at 50% 0%, #cbd5e1 0%, #f8fafc 65%)'
                : 'radial-gradient(ellipse at 50% 0%, #1c1c2e 0%, #0a0a0c 65%)',
        }}>
            {/* Background Decorative Blobs */}
            <Box sx={{
                position: 'fixed', top: '10%', left: '-5%', width: '40vw', height: '40vw',
                background: isLight ? 'rgba(59, 130, 246, 0.08)' : 'rgba(59, 130, 246, 0.03)',
                filter: 'blur(120px)', borderRadius: '50%', zIndex: 0, pointerEvents: 'none',
                display: { xs: 'none', xl: 'block' }
            }} />
            <Box sx={{
                position: 'fixed', bottom: '10%', right: '-5%', width: '35vw', height: '35vw',
                background: isLight ? 'rgba(16, 185, 129, 0.08)' : 'rgba(16, 185, 129, 0.03)',
                filter: 'blur(120px)', borderRadius: '50%', zIndex: 0, pointerEvents: 'none',
                display: { xs: 'none', xl: 'block' }
            }} />

            {/* Top Navigation */}
            <Navbar />

            {/* Main Content */}
            <Box sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                px: { xs: 3, md: 6 },
                py: 6,
                position: 'relative',
                zIndex: 1
            }}>
                <Box sx={{ maxWidth: { xs: 1100, lg: 1440, xl: 1800 }, width: '94%', mx: 'auto' }}>
                    <Hero />
                    <FeaturesGrid />
                    <CourseCatalog searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
                </Box>
            </Box>


            {/* Footer */}
            <Footer />
        </Box>
    );
};
